export default "__VITE_ASSET__86419fbd__"